import { LoginCallback, Security } from "@okta/okta-react";
import {
    Navigate,
    RouterProvider,
    createBrowserRouter,
    useNavigation,
} from "react-router-dom";
import React, { useEffect, useState } from "react";

import AdminLayout from "./AdminLayout";
import AdminManagement from "../Foundation/AdministratorManagement/AdministratorManagement";
import AppLayout from "./AppLayout";
import AssessmentManagement from "../Svt-Admin/Pages/AssessmentManagement/AssessmentManagement";
import CSVViewer from "../DocumentManagementSystem/CSVViewer";
import Dashboard from "../common/Dashboard";
import DistributionListManagement from "../Foundation/DistributionManagement/DistributionList";
import DocManageSys from "../DocumentManagementSystem/DocumentManageSys";
import ExternalUserManagement from "../Foundation/External User Management/ExternalUserManagement";
import FileViewer from "../DocumentManagementSystem/FileViewer";
import GroupDetails from "../Foundation/DistributionManagement/GroupDetails";
import IdleLogout from "./idealTimeOut";
import LandingPage from "../Landing Page/LandingPage";
import LevelManagement from "../Svt-Admin/Pages/LevelManagement/LevelManagement";
import LoginPage from "../Login Page/LoginPage";
import NotFoundPage from "../ErrorBoundry/ErrorPage";
import { OktaAuth } from "@okta/okta-auth-js";
import OpeningPage from "../Survey/SurveyUser/OpeningPage";
import OrganizationManagement from "../Foundation/OrganizationManagement/OrganizationManagement";
import PICManagement from "../Svt-Admin/Pages/PICManagement/PICManagement";
import QuestionPage from "../Survey/QuestionPage";
import RCMManagement from "../Svt-Admin/Pages/RCMManagement/RCMManagement";
import RequireAuth from "./RequireAuth";
import SelfVerificationMain from "../Self-Verification Tool/SelfVerificationMain";
import SlotManagement from "../Svt-Admin/Pages/SlotManagement/SlotManagement";
import SurveyDashboard from "../Survey/SurveyDashboard";
import SurveyLinkRedirect from "../Survey/SurveyUser/SurveyLinkRedirect";
import SurveyManagement from "../Survey/SurveyManagement";
import SurveyPage from "../Survey/SurveyPage";
import SurveyResponse from "../Survey/SurveyUser/SurveyResponse";
import TemplateManagement from "../Svt-Admin/Pages/TemplateManagement/TemplateManagement";
import UserDocumentManagement from "../DocumentManagementSystem/UserDocManagement";
import UserLayout from "./UserLayout";
import UserQuestionsPage from "../Survey/SurveyUser/UserQuestionsPage";
import UserSurveyManagement from "./../Survey/SurveyUser/UserSurveyManagement";
import UserSurveyResponse from "../Survey/SurveyUser/UserSurveyResponse";
import NotificationManageMent from "../NotificationManagement/NotificationManagement";
import DomainManagement from "../Foundation/DomainManagement/DomainManagement";
import RouteErrorBoundary from "../ErrorBoundry/RouterError";
import { getOktaConfig } from "../../oktaConfig";

const oktaAuth = new OktaAuth(getOktaConfig());

const Body = (props) => {
    const [isLoggedIn, setIsLoggedIn] = useState(
        localStorage.getItem("isUserLoggedIn") === "true"
    );

    const handleLogin = () => {
        //setIsLoggedIn(true);
        //localStorage.setItem("isUserLoggedIn", "true");
    };
    const appRouter = createBrowserRouter([
        {
            path: "/login",
            element: <LoginPage onLogin={handleLogin} />,
        },
        {
            path: "/login/callback",
            element: <LoginCallback />,
        },
        {
            path: "/view-csv-document/:fileName",
            element: <CSVViewer />,
        },
        {
            path: "/view-document/:fileName",
            element: <FileViewer />,
        },

        {
            path: "/survey/:surveyId/:code/:languageId",
            element: <SurveyLinkRedirect />,
        },

        {
            path: "/",
            element: (
                <IdleLogout>
                    <RequireAuth>
                        <AppLayout getLocationName={props.getLocation} />
                    </RequireAuth>
                </IdleLogout>
            ),
             errorElement: <RouteErrorBoundary />,
            children: [
                {
                    index: true,
                    element: <Navigate to="/home" replace />,
                },
                {
                    path: "/home",
                    element: <LandingPage />,
                },
                {
                    path: "/user",
                    element: <UserLayout />,
                    children: [
                        {
                            path: "self-verification",
                            element: <SelfVerificationMain />,
                        },
                        {
                            path: "dms",
                            element: <UserDocumentManagement />,
                        },
                        {
                            path: "survey",
                            element: <UserSurveyManagement />,
                        },
                        {
                            path: "survey/opening-page",
                            element: <OpeningPage />,
                        },
                        {
                            path: "survey/opening-page/ques-page",
                            element: <UserQuestionsPage />,
                        },
                        {
                            path: "survey/opening-page/ques-page/response-page",
                            element: <SurveyResponse />,
                        },
                        {
                            path: "survey/user-response-page",
                            element: <UserSurveyResponse />,
                        },
                        // {
                        //     path: "survey/:surveyId",
                        //     element: <SurveyLinkRedirect />,
                        // },
                        {
                            path: "dashboard",
                            element: <Dashboard />,
                        },
                    ],
                },
                {
                    path: "/admin",
                    element: <AdminLayout />, // Admin layout wrapper
                    children: [
                        {
                            path: "foundation",
                            children: [
                                {
                                    path: "administrator-management",
                                    element: <AdminManagement />,
                                },
                                {
                                    path: "organization-management",
                                    element: <OrganizationManagement />,
                                },
                                {
                                    path: "group-management",
                                    element: <DistributionListManagement />,
                                },
                                {
                                    path: "distribution-list/group-details",
                                    element: <GroupDetails />,
                                },
                                {
                                    path: "picmanagement",
                                    element: <PICManagement />,
                                },
                                {
                                    path: "rcmmanagement",
                                    element: <RCMManagement />,
                                },
                                {
                                    path: "external-user-management",
                                    element: <ExternalUserManagement />,
                                }, {
                                    path: "domain-management",
                                    element: <DomainManagement />,
                                },
                            ],
                        },
                        {
                            path: "self-verification",
                            children: [
                                {
                                    path: "levelmanagement",
                                    element: <LevelManagement />,
                                },
                                {
                                    path: "templatemanagement",
                                    element: <TemplateManagement />,
                                },
                                {
                                    path: "slotmanagement",
                                    element: <SlotManagement />,
                                },
                                {
                                    path: "assessment",
                                    element: <AssessmentManagement />,
                                },
                                {
                                    path: "dashboard",
                                    element: <Dashboard />,
                                },
                            ],
                        },
                        {
                            path: "dms",
                            element: <DocManageSys />,
                        },
                        {
                            path: "survey",
                            element: <SurveyManagement />,
                        },
                        {
                            path: "survey/survey-page",
                            element: <SurveyPage />,
                        },
                        {
                            path: "survey/survey-page/question-page",
                            element: <QuestionPage />,
                        },
                        {
                            path: "survey/dashboard",
                            element: <SurveyDashboard />,
                        },
                        {
                            path: "notification/notification-management",
                            element: <NotificationManageMent />,
                        }
                    ],
                },
            ],
        },
        {
            path: "*",
            element: <NotFoundPage />,
        },
    ]);

    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        window.location.replace(originalUri || "/");
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <div style={{ width: "100%", display: "flex" }}>
                <RouterProvider router={appRouter} />
            </div>
        </Security>
    );
};

export default Body;
